import {
  CustomGetDailyFormWorkOrderQuery,
  useCustomGetDailyFormWorkOrderQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";

export default function useGetDailyFormWorkOrder({ id }: { id: string }) {
  const { loading, error, data: graphqlData } = useCustomGetDailyFormWorkOrderQuery({
    variables: { id },
  });

  const getData = useCallback((data?: CustomGetDailyFormWorkOrderQuery) => {
    return data?.getDailyFormWorkOrder || null;
  }, []);

  const data = useMemo(() => getData(graphqlData), [graphqlData, getData]);

  return { loading, error, data, getData };
}
